<template>
  <div class="pc">
    <div class="left">
      <div
        :class="{
          item: data.value != '中昆图片_展品',
          item_active: data.value == '中昆图片_展品',
        }"
        @click="getData('中昆图片_展品')"
      >
        展品
      </div>
      <div
        :class="{
          item: data.value != '中昆图片_原木框',
          item_active: data.value == '中昆图片_原木框',
        }"
        @click="getData('中昆图片_原木框')"
      >
        装框标本-原木框
      </div>
      <div
        :class="{
          item: data.value != '中昆图片_胡桃木框',
          item_active: data.value == '中昆图片_胡桃木框',
        }"
        @click="getData('中昆图片_胡桃木框')"
      >
        装框标本-胡桃木框
      </div>
      <div
        :class="{
          item: data.value != '中昆图片_黑框',
          item_active: data.value == '中昆图片_黑框',
        }"
        @click="getData('中昆图片_黑框')"
      >
        装框标本-黑框
      </div>
      <div
        :class="{
          item: data.value != '中昆图片_白框',
          item_active: data.value == '中昆图片_白框',
        }"
        @click="getData('中昆图片_白框')"
      >
        装框标本-白框
      </div>
      <div
        :class="{
          item: data.value != '中昆图片_棕框',
          item_active: data.value == '中昆图片_棕框',
        }"
        @click="getData('中昆图片_棕框')"
      >
        装框标本-棕框
      </div>
      <div
        :class="{
          item: data.value != '中昆图片_塑料框',
          item_active: data.value == '中昆图片_塑料框',
        }"
        @click="getData('中昆图片_塑料框')"
      >
        装框标本-塑料框
      </div>
      <div
        :class="{
          item: data.value != '中昆图片_生活史',
          item_active: data.value == '中昆图片_生活史',
        }"
        @click="getData('中昆图片_生活史')"
      >
        装框标本-生活史
      </div>
      <div
        :class="{
          item: data.value != '中昆图片_分解标本',
          item_active: data.value == '中昆图片_分解标本',
        }"
        @click="getData('中昆图片_分解标本')"
      >
        装框标本-分解标本
      </div>
    </div>
  </div>
  <div class="mobile"></div>
</template>

<script>
import { reactive } from "vue";
export default {
  setup() {
    let data = reactive({
      data: {},
      item_value: "中昆图片_展品", //用于判断样式
    });
    let dataToSql = reactive({
      para_01: "",
      para_02: "",
      para_03: "",
      para_04: "",
      para_05: "",
      para_06: "",
      para_07: "",
      para_08: "",
      input: "",
    });

    const getData = (value) => {
      data.value = value;
      dataToSql.para_01 = value;
    };

    return {
      data,
      dataToSql,
      getData,
    };
  },
};
</script>

<style lang="less" scoped>
.pc {
  @media only screen and (max-width: 800px) {
    display: none;
  }
  .left {
    position: fixed;
    width: 200px;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: rgb(230, 230, 230);
    display: flex;
    flex-direction: column;
    padding: 120px 0 0 0;
    .item {
      text-align: left;

      width: 100%;
      padding: 8px 0 8px 20px;
    }
    .item_active {
      text-align: left;
      font-weight: bold;
      background-color: rgb(255, 255, 255);
      width: 100%;
      padding: 8px 0 8px 20px;
    }
  }
}

.mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 0 10vh 0;
  padding: 0;
}
</style>
